import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Dimmer,
  Grid,
  Loader,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import qs from 'qs';
import Form from './Form';

import { flashErrorMessage, flashSuccessMessage } from '../../actions/flash';
import { fetchM, serverRequestPost } from '../../actions/fetchM';
import { TRANSLATION_FILES } from '../../constants/translation';

class New extends Component {
  static propTypes = {
    checkChanges: PropTypes.func,
    onUpdated: PropTypes.func,
    projectBankAccount: PropTypes.oneOfType([
      PropTypes.array,
    ]),
    resetChanges: PropTypes.func,
    token: PropTypes.string,
    bookingData: PropTypes.oneOfType([
      PropTypes.object,
    ]),
  }
  static contextTypes = {
    router: PropTypes.object,
    store: PropTypes.object,
  }
  static getPropsToState = (props) => {
    const projectBankAccount = props.projectBankAccount;
    return {
      projectBankAccount,
    };
  }
  constructor(props) {
    super(props);
    const state = New.getPropsToState(props);

    this.state = {
      genericErrMsg: props.t('An error occurred, please refresh page'),
      loading: false,
      ...state,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = New.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  async handleError(store, msg, errorObj, isBugsnag = false) {
    await this.setLoading(false);
    await store.dispatch(flashErrorMessage({ message: msg }));
    if (isBugsnag) Bugsnag.notifyException(errorObj);
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  handleCreatePayment = async (value) => {
    const { data: paymentData, picturesUploaded, picturesUploadedCount } = value;
    const { genericErrMsg } = this.state;
    const { store, router } = this.context;
    const { t } = this.props;
    if (paymentData.paymentMethodTypeID === 'credit_card' && (!value.data.creditCardLastFourDigits || (value.data.creditCardLastFourDigits && value.data.creditCardLastFourDigits.length !== 4))) {
      store.dispatch(flashErrorMessage({ message: t('Kindly fill in the last 4 digits of your Credit Card') }));
      return;
    }
    await this.setLoading(true);
    let response;
    const bfpQuery = {
      pendingAttachments: picturesUploadedCount > 0,
    };

    try {
      response = await serverRequestPost(
        `/bookings/${router.params.id}/booking_fee_payments/?${qs.stringify(bfpQuery)}`,
        store,
        this.props.token,
        paymentData,
      );
    } catch (error) {
      await this.setLoading(false);
      this.handleError(store, genericErrMsg, error, true);
      return;
    }
    if (response.error) {
      await this.setLoading(false);
      this.handleError(store, response.message);
    } else if (picturesUploadedCount > 0) {
      let res;
      const picQuery = {
        FPID: response.data.id,
        isCreatingBFP: true,
      };

      try {
        res = await store.dispatch(fetchM(`/bookings/${router.params.id}/pictures/?${qs.stringify(picQuery)}`, {
          credentials: 'include',
          method: 'POST',
          headers: {
            'X-Csrf-Token': this.props.token,
          },
          body: picturesUploaded,
        }));
      } catch (e) {
        await this.setLoading(false);
        if (e.res && e.res.status >= 400 && e.res.status < 500) {
          const message = await e.res.text();
          store.dispatch(flashErrorMessage({ message }));
          return;
        }
        Bugsnag.notifyException(e);
        await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
        return;
      }
      await this.setLoading(false);
      if (!res.ok) {
        const message = await res.text();
        await store.dispatch(flashErrorMessage({ message }));
      } else {
        this.props.onUpdated();
        if (this.props.resetChanges) this.props.resetChanges('BookingFeePayment');
        store.dispatch(flashSuccessMessage({
          header: t('Create Success'),
          message: t('Payment successfully created'),
        }));
      }
    } else {
      await this.setLoading(false);
      this.props.onUpdated();
      if (this.props.resetChanges) this.props.resetChanges('BookingFeePayment');
      if (paymentData.paymentMethodTypeID === 'online_payment') {
        store.dispatch(flashSuccessMessage({
          header: t('Payment Request Success'),
          message: t('An email notification and SMS with the payment request link is successfully sent to Purchaser. The link will expire in 24 hours.'),
        }));
      } else {
        store.dispatch(flashSuccessMessage({
          header: t('Create Success'),
          message: t('Payment successfully created'),
        }));
      }
    }
  }
  handleResetChange = (sectionName) => {
    if (this.props.resetChanges) this.props.resetChanges(sectionName);
  }
  render() {
    const { projectBankAccount } = this.state;
    const { t } = this.props;
    return (
      <div>
        <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
          {this.state.loading && <Loader inline="centered">{t('Loading')}</Loader>}
        </Dimmer>
        <Grid centered>
          <Form
            bookingData={this.props.bookingData}
            checkChanges={this.props.checkChanges}
            onCreate={this.handleCreatePayment}
            projectBankAccount={projectBankAccount}
            resetChanges={this.handleResetChange}
          />
        </Grid>
      </div>
    );
  }
}
export default withTranslation(TRANSLATION_FILES.translation)(New);



// WEBPACK FOOTER //
// ./src/containers/BookingPayment/New.jsx